<footer class="footer">
  <div class="footer__in">
    <div class="footer__top">
      <div class="footer__brand">
        <a href="/" (click)="goToTop($event)" class="footer__logo-link" aria-label="Bilload">
          <img src="assets/logo.png" alt="Bilload" class="footer__logo">
        </a>
        <p>{{ t('landing.footer.tagline1') }}<br>{{ t('landing.footer.tagline2') }}</p>
      </div>

      <nav class="footer__col" [attr.aria-label]="t('footer.product')">
        <h4>{{ t('footer.product') }}</h4>
        <a href="/#sol" (click)="goToSection($event, 'sol')">{{ t('footer.features') }}</a>
        <a href="/#tar" (click)="goToSection($event, 'tar')">{{ t('footer.tariffs') }}</a>
        <a href="/#cases" (click)="goToSection($event, 'cases')">{{ t('footer.cases') }}</a>
        <a href="/tnved" (click)="goToPage($event, '/tnved')">{{ t('footer.tnved') }}</a>
      </nav>

      <nav class="footer__col" [attr.aria-label]="t('footer.documents')">
        <h4>{{ t('footer.documents') }}</h4>
        <a href="/user-agreement" (click)="goToPage($event, '/user-agreement')">{{ t('footer.userAgreement') }}</a>
        <a href="/privacy-policy" (click)="goToPage($event, '/privacy-policy')">{{ t('footer.privacyPolicy') }}</a>
        <a href="#">{{ t('footer.forInvestors') }}</a>
      </nav>

      <div class="footer__col">
        <h4>{{ t('footer.contactsTitle') }}</h4>
        <a [href]="'mailto:' + email">{{ email }}</a>
        <a [href]="phoneHref">{{ phone }}</a>

        <span class="footer__follow">{{ t('footer.follow') }}</span>
        <div class="footer__social">
          <a [href]="linkedinHref" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8 11v5M8 8v.01M12 16v-5M12 13c0-3 4-3 4 0v3"/></svg>
          </a>
          <a [href]="instagramHref" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="5"/><circle cx="12" cy="12" r="3.5"/></svg>
          </a>
          <a [href]="telegramHref" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 4.5 3.5 11.2l5.6 2.1 2.1 6 3-3.9 4.9 3.6z"/><path d="m9.1 13.3 8.4-6.3-6.3 8.1"/></svg>
          </a>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <span>{{ t('footer.rights') }}</span>
    </div>
  </div>
</footer>
